import { makeStyles } from '@material-ui/core';

export default makeStyles({
  root: {
    maxHeight: '270px',
    overflow: 'auto',
  },
});
